import state from './botState'
import mutations from './botMutations'
import getters from './botGetters'
import actions from './botActions'

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
